import camelcaseKeys from 'camelcase-keys'
import { PageObjectButton } from '@/entities/webapp-pages/page-objects/Button.js'
import { PageObjectLinkedContent } from '@/entities/webapp-pages/page-objects/LinkedContent.js'
import { PageObjectRelatedPage } from '@/entities/webapp-pages/page-objects/RelatedPage.js'
import { PageObjectLocation } from '@/entities/webapp-pages/page-objects/Location.js'
import { PageObjectAgenda } from '@/entities/webapp-pages/page-objects/Agenda.js'
import { getFileURL } from '@/lib/helpers/FileURLGetter'

export class PageContent {
  constructor (params = {}) {
    const { content, buttons, linkedContent, relatedPages, location: webappLocation, agenda } = camelcaseKeys(params ? params : {}, { deep: true })
    const { id, title, shortDescription, description, dressCode, imageFileIds } = camelcaseKeys(content || {}, { deep: true })
    this.id = id || null
    this.title = title || []
    this.shortDescription = shortDescription || []
    this.description = description || []
    this.location = webappLocation ? new PageObjectLocation(webappLocation) : null
    this.dressCode = dressCode || []
    this.imageFileIds = imageFileIds || []
    this.imageFiles = Array.isArray(this.imageFileIds) ? this.imageFileIds.map((imageFileId) => getFileURL(imageFileId)) : []
    this.agenda = agenda ? agenda.map(a => new PageObjectAgenda(a)) : []

    this.buttons = Array.isArray(buttons) ? buttons.map((button) => new PageObjectButton(button)) : null
    this.linkedContent = Array.isArray(linkedContent) ? linkedContent.map((content) => new PageObjectLinkedContent(content)) : null
    this.relatedPages = Array.isArray(relatedPages) ? relatedPages.map((relatedPage) => new PageObjectRelatedPage(relatedPage)) : null
  }
}
